import { createFileRoute } from "@tanstack/react-router";
import { PasswordResetDone } from "@pages/password-reset/password-reset-done/password-reset-done";

export const Route = createFileRoute(
  "/_passwordreset-layout/passwordreset/done",
)({
  component: PasswordResetDone,
});
